import type { SearchResponse } from '@algolia/client-search';

import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';
import { SearchResultsHeaderCount } from '#/modules/search/components/Results/Header/SearchResultsHeaderCount';
import { SaveSearchButton } from '#/modules/search/components/SaveSearch/SaveSearchButton';

import {
  ViewListingPageSidebarResultsHeaderHolder,
  ViewListingPageSidebarResultsHeaderLeftSide,
  ViewListingPageSidebarResultsHeaderRightSide,
  ViewListingPageSidebarResultsHeaderWrapper,
} from './ViewListingPageSidebarResultsHeader.styled';

type Props = {
  results: SearchResponse<SearchAlgoliaHit> | undefined;
  isSearching: boolean;
  saveSearch: () => Promise<void>;
  listingType: 'JOB' | 'VOLOP';
};

export function ViewListingPageSidebarResultsHeader({
  results,
  isSearching,
  saveSearch,
  listingType,
}: Props) {
  return (
    <ViewListingPageSidebarResultsHeaderHolder>
      <ViewListingPageSidebarResultsHeaderWrapper>
        <ViewListingPageSidebarResultsHeaderLeftSide>
          <SearchResultsHeaderCount
            count={!isSearching && results ? results.nbHits! : null}
            searchType={listingType}
          />
        </ViewListingPageSidebarResultsHeaderLeftSide>
        <ViewListingPageSidebarResultsHeaderRightSide>
          <SaveSearchButton saveSearch={saveSearch} />
        </ViewListingPageSidebarResultsHeaderRightSide>
      </ViewListingPageSidebarResultsHeaderWrapper>
    </ViewListingPageSidebarResultsHeaderHolder>
  );
}
